export default "/images/voicemail.svg?cbc9921fe3f16eca97410f4eb5046692";